/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRequestCourseBillingGroupPost } from '../fn/course-request/api-request-course-billing-group-post';
import { ApiRequestCourseBillingGroupPost$Params } from '../fn/course-request/api-request-course-billing-group-post';
import { apiRequestCourseBillingPost } from '../fn/course-request/api-request-course-billing-post';
import { ApiRequestCourseBillingPost$Params } from '../fn/course-request/api-request-course-billing-post';
import { apiRequestCourseChangeCourseGroupPost } from '../fn/course-request/api-request-course-change-course-group-post';
import { ApiRequestCourseChangeCourseGroupPost$Params } from '../fn/course-request/api-request-course-change-course-group-post';
import { apiRequestCourseChangeCoursePost } from '../fn/course-request/api-request-course-change-course-post';
import { ApiRequestCourseChangeCoursePost$Params } from '../fn/course-request/api-request-course-change-course-post';
import { apiRequestCourseConfirmCoursePost } from '../fn/course-request/api-request-course-confirm-course-post';
import { ApiRequestCourseConfirmCoursePost$Params } from '../fn/course-request/api-request-course-confirm-course-post';
import { apiRequestCourseConfirmGroupPost } from '../fn/course-request/api-request-course-confirm-group-post';
import { ApiRequestCourseConfirmGroupPost$Params } from '../fn/course-request/api-request-course-confirm-group-post';
import { apiRequestCourseGetRequestByIdGet } from '../fn/course-request/api-request-course-get-request-by-id-get';
import { ApiRequestCourseGetRequestByIdGet$Params } from '../fn/course-request/api-request-course-get-request-by-id-get';
import { apiRequestCourseGetRequestGroupByIdGet } from '../fn/course-request/api-request-course-get-request-group-by-id-get';
import { ApiRequestCourseGetRequestGroupByIdGet$Params } from '../fn/course-request/api-request-course-get-request-group-by-id-get';
import { apiRequestCourseGetRequestGroupGet } from '../fn/course-request/api-request-course-get-request-group-get';
import { ApiRequestCourseGetRequestGroupGet$Params } from '../fn/course-request/api-request-course-get-request-group-get';
import { apiRequestCourseInitialGet } from '../fn/course-request/api-request-course-initial-get';
import { ApiRequestCourseInitialGet$Params } from '../fn/course-request/api-request-course-initial-get';
import { apiRequestCoursePaymentGroupPost } from '../fn/course-request/api-request-course-payment-group-post';
import { ApiRequestCoursePaymentGroupPost$Params } from '../fn/course-request/api-request-course-payment-group-post';
import { apiRequestCoursePaymentPost } from '../fn/course-request/api-request-course-payment-post';
import { ApiRequestCoursePaymentPost$Params } from '../fn/course-request/api-request-course-payment-post';
import { apiRequestCoursePreviewCertificateGet } from '../fn/course-request/api-request-course-preview-certificate-get';
import { ApiRequestCoursePreviewCertificateGet$Params } from '../fn/course-request/api-request-course-preview-certificate-get';
import { apiRequestCourseRegisterGroupPost } from '../fn/course-request/api-request-course-register-group-post';
import { ApiRequestCourseRegisterGroupPost$Params } from '../fn/course-request/api-request-course-register-group-post';
import { apiRequestCourseRegisterPost } from '../fn/course-request/api-request-course-register-post';
import { ApiRequestCourseRegisterPost$Params } from '../fn/course-request/api-request-course-register-post';
import { apiRequestCourseResultCoursePost } from '../fn/course-request/api-request-course-result-course-post';
import { ApiRequestCourseResultCoursePost$Params } from '../fn/course-request/api-request-course-result-course-post';
import { apiRequestCourseResultGroupPost } from '../fn/course-request/api-request-course-result-group-post';
import { ApiRequestCourseResultGroupPost$Params } from '../fn/course-request/api-request-course-result-group-post';
import { apiRequestCourseSaveBillingPost } from '../fn/course-request/api-request-course-save-billing-post';
import { ApiRequestCourseSaveBillingPost$Params } from '../fn/course-request/api-request-course-save-billing-post';
import { apiRequestCourseSavePaymentPost } from '../fn/course-request/api-request-course-save-payment-post';
import { ApiRequestCourseSavePaymentPost$Params } from '../fn/course-request/api-request-course-save-payment-post';
import { apiRequestCourseVerifyGroupPost } from '../fn/course-request/api-request-course-verify-group-post';
import { ApiRequestCourseVerifyGroupPost$Params } from '../fn/course-request/api-request-course-verify-group-post';
import { apiRequestCourseVerifyPost } from '../fn/course-request/api-request-course-verify-post';
import { ApiRequestCourseVerifyPost$Params } from '../fn/course-request/api-request-course-verify-post';
import { CourseCertificate } from '../models/course-certificate';
import { CourseRequest } from '../models/course-request';
import { CourseRequestGroup } from '../models/course-request-group';
import { CourseRequestGroupApiRespModel } from '../models/course-request-group-api-resp-model';
import { RequestResult } from '../models/request-result';
import { RequestResultApiRespModel } from '../models/request-result-api-resp-model';

@Injectable({ providedIn: 'root' })
export class CourseRequestService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRequestCourseInitialGet()` */
  static readonly ApiRequestCourseInitialGetPath = '/api/Request/Course/Initial';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseInitialGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCourseInitialGet$Response(params?: ApiRequestCourseInitialGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequest>> {
    return apiRequestCourseInitialGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseInitialGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCourseInitialGet(params?: ApiRequestCourseInitialGet$Params, context?: HttpContext): Observable<CourseRequest> {
    return this.apiRequestCourseInitialGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseRequest>): CourseRequest => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseGetRequestByIdGet()` */
  static readonly ApiRequestCourseGetRequestByIdGetPath = '/api/Request/Course/GetRequestById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseGetRequestByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCourseGetRequestByIdGet$Response(params?: ApiRequestCourseGetRequestByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequest>> {
    return apiRequestCourseGetRequestByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseGetRequestByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCourseGetRequestByIdGet(params?: ApiRequestCourseGetRequestByIdGet$Params, context?: HttpContext): Observable<CourseRequest> {
    return this.apiRequestCourseGetRequestByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseRequest>): CourseRequest => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseGetRequestGroupGet()` */
  static readonly ApiRequestCourseGetRequestGroupGetPath = '/api/Request/Course/GetRequestGroup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseGetRequestGroupGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCourseGetRequestGroupGet$Response(params?: ApiRequestCourseGetRequestGroupGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequestGroup>> {
    return apiRequestCourseGetRequestGroupGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseGetRequestGroupGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCourseGetRequestGroupGet(params?: ApiRequestCourseGetRequestGroupGet$Params, context?: HttpContext): Observable<CourseRequestGroup> {
    return this.apiRequestCourseGetRequestGroupGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseRequestGroup>): CourseRequestGroup => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseGetRequestGroupByIdGet()` */
  static readonly ApiRequestCourseGetRequestGroupByIdGetPath = '/api/Request/Course/GetRequestGroupById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseGetRequestGroupByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCourseGetRequestGroupByIdGet$Response(params?: ApiRequestCourseGetRequestGroupByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequestGroup>> {
    return apiRequestCourseGetRequestGroupByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseGetRequestGroupByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCourseGetRequestGroupByIdGet(params?: ApiRequestCourseGetRequestGroupByIdGet$Params, context?: HttpContext): Observable<CourseRequestGroup> {
    return this.apiRequestCourseGetRequestGroupByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseRequestGroup>): CourseRequestGroup => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseRegisterPost()` */
  static readonly ApiRequestCourseRegisterPostPath = '/api/Request/Course/Register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseRegisterPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseRegisterPost$Response(params?: ApiRequestCourseRegisterPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestResultApiRespModel>> {
    return apiRequestCourseRegisterPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseRegisterPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseRegisterPost(params?: ApiRequestCourseRegisterPost$Params, context?: HttpContext): Observable<RequestResultApiRespModel> {
    return this.apiRequestCourseRegisterPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<RequestResultApiRespModel>): RequestResultApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseRegisterGroupPost()` */
  static readonly ApiRequestCourseRegisterGroupPostPath = '/api/Request/Course/RegisterGroup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseRegisterGroupPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseRegisterGroupPost$Response(params?: ApiRequestCourseRegisterGroupPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequestGroupApiRespModel>> {
    return apiRequestCourseRegisterGroupPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseRegisterGroupPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseRegisterGroupPost(params?: ApiRequestCourseRegisterGroupPost$Params, context?: HttpContext): Observable<CourseRequestGroupApiRespModel> {
    return this.apiRequestCourseRegisterGroupPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseRequestGroupApiRespModel>): CourseRequestGroupApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseVerifyGroupPost()` */
  static readonly ApiRequestCourseVerifyGroupPostPath = '/api/Request/Course/VerifyGroup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseVerifyGroupPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseVerifyGroupPost$Response(params?: ApiRequestCourseVerifyGroupPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequestGroupApiRespModel>> {
    return apiRequestCourseVerifyGroupPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseVerifyGroupPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseVerifyGroupPost(params?: ApiRequestCourseVerifyGroupPost$Params, context?: HttpContext): Observable<CourseRequestGroupApiRespModel> {
    return this.apiRequestCourseVerifyGroupPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseRequestGroupApiRespModel>): CourseRequestGroupApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseBillingGroupPost()` */
  static readonly ApiRequestCourseBillingGroupPostPath = '/api/Request/Course/BillingGroup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseBillingGroupPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseBillingGroupPost$Response(params?: ApiRequestCourseBillingGroupPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequestGroupApiRespModel>> {
    return apiRequestCourseBillingGroupPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseBillingGroupPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseBillingGroupPost(params?: ApiRequestCourseBillingGroupPost$Params, context?: HttpContext): Observable<CourseRequestGroupApiRespModel> {
    return this.apiRequestCourseBillingGroupPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseRequestGroupApiRespModel>): CourseRequestGroupApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiRequestCoursePaymentGroupPost()` */
  static readonly ApiRequestCoursePaymentGroupPostPath = '/api/Request/Course/PaymentGroup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCoursePaymentGroupPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCoursePaymentGroupPost$Response(params?: ApiRequestCoursePaymentGroupPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequestGroupApiRespModel>> {
    return apiRequestCoursePaymentGroupPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCoursePaymentGroupPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCoursePaymentGroupPost(params?: ApiRequestCoursePaymentGroupPost$Params, context?: HttpContext): Observable<CourseRequestGroupApiRespModel> {
    return this.apiRequestCoursePaymentGroupPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseRequestGroupApiRespModel>): CourseRequestGroupApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseConfirmGroupPost()` */
  static readonly ApiRequestCourseConfirmGroupPostPath = '/api/Request/Course/ConfirmGroup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseConfirmGroupPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseConfirmGroupPost$Response(params?: ApiRequestCourseConfirmGroupPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequestGroupApiRespModel>> {
    return apiRequestCourseConfirmGroupPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseConfirmGroupPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseConfirmGroupPost(params?: ApiRequestCourseConfirmGroupPost$Params, context?: HttpContext): Observable<CourseRequestGroupApiRespModel> {
    return this.apiRequestCourseConfirmGroupPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseRequestGroupApiRespModel>): CourseRequestGroupApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseResultGroupPost()` */
  static readonly ApiRequestCourseResultGroupPostPath = '/api/Request/Course/ResultGroup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseResultGroupPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseResultGroupPost$Response(params?: ApiRequestCourseResultGroupPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequestGroupApiRespModel>> {
    return apiRequestCourseResultGroupPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseResultGroupPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseResultGroupPost(params?: ApiRequestCourseResultGroupPost$Params, context?: HttpContext): Observable<CourseRequestGroupApiRespModel> {
    return this.apiRequestCourseResultGroupPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseRequestGroupApiRespModel>): CourseRequestGroupApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseVerifyPost()` */
  static readonly ApiRequestCourseVerifyPostPath = '/api/Request/Course/Verify';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseVerifyPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseVerifyPost$Response(params?: ApiRequestCourseVerifyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestResult>> {
    return apiRequestCourseVerifyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseVerifyPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseVerifyPost(params?: ApiRequestCourseVerifyPost$Params, context?: HttpContext): Observable<RequestResult> {
    return this.apiRequestCourseVerifyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<RequestResult>): RequestResult => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseChangeCoursePost()` */
  static readonly ApiRequestCourseChangeCoursePostPath = '/api/Request/Course/ChangeCourse';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseChangeCoursePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseChangeCoursePost$Response(params?: ApiRequestCourseChangeCoursePost$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestResultApiRespModel>> {
    return apiRequestCourseChangeCoursePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseChangeCoursePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseChangeCoursePost(params?: ApiRequestCourseChangeCoursePost$Params, context?: HttpContext): Observable<RequestResultApiRespModel> {
    return this.apiRequestCourseChangeCoursePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<RequestResultApiRespModel>): RequestResultApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseChangeCourseGroupPost()` */
  static readonly ApiRequestCourseChangeCourseGroupPostPath = '/api/Request/Course/ChangeCourseGroup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseChangeCourseGroupPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseChangeCourseGroupPost$Response(params?: ApiRequestCourseChangeCourseGroupPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestResultApiRespModel>> {
    return apiRequestCourseChangeCourseGroupPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseChangeCourseGroupPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseChangeCourseGroupPost(params?: ApiRequestCourseChangeCourseGroupPost$Params, context?: HttpContext): Observable<RequestResultApiRespModel> {
    return this.apiRequestCourseChangeCourseGroupPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<RequestResultApiRespModel>): RequestResultApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseBillingPost()` */
  static readonly ApiRequestCourseBillingPostPath = '/api/Request/Course/Billing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseBillingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseBillingPost$Response(params?: ApiRequestCourseBillingPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestResult>> {
    return apiRequestCourseBillingPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseBillingPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseBillingPost(params?: ApiRequestCourseBillingPost$Params, context?: HttpContext): Observable<RequestResult> {
    return this.apiRequestCourseBillingPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<RequestResult>): RequestResult => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseSaveBillingPost()` */
  static readonly ApiRequestCourseSaveBillingPostPath = '/api/Request/Course/SaveBilling';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseSaveBillingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseSaveBillingPost$Response(params?: ApiRequestCourseSaveBillingPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestResult>> {
    return apiRequestCourseSaveBillingPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseSaveBillingPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseSaveBillingPost(params?: ApiRequestCourseSaveBillingPost$Params, context?: HttpContext): Observable<RequestResult> {
    return this.apiRequestCourseSaveBillingPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<RequestResult>): RequestResult => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseSavePaymentPost()` */
  static readonly ApiRequestCourseSavePaymentPostPath = '/api/Request/Course/SavePayment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseSavePaymentPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseSavePaymentPost$Response(params?: ApiRequestCourseSavePaymentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestResult>> {
    return apiRequestCourseSavePaymentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseSavePaymentPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseSavePaymentPost(params?: ApiRequestCourseSavePaymentPost$Params, context?: HttpContext): Observable<RequestResult> {
    return this.apiRequestCourseSavePaymentPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<RequestResult>): RequestResult => r.body)
    );
  }

  /** Path part for operation `apiRequestCoursePaymentPost()` */
  static readonly ApiRequestCoursePaymentPostPath = '/api/Request/Course/Payment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCoursePaymentPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCoursePaymentPost$Response(params?: ApiRequestCoursePaymentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestResult>> {
    return apiRequestCoursePaymentPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCoursePaymentPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCoursePaymentPost(params?: ApiRequestCoursePaymentPost$Params, context?: HttpContext): Observable<RequestResult> {
    return this.apiRequestCoursePaymentPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<RequestResult>): RequestResult => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseConfirmCoursePost()` */
  static readonly ApiRequestCourseConfirmCoursePostPath = '/api/Request/Course/ConfirmCourse';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseConfirmCoursePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseConfirmCoursePost$Response(params?: ApiRequestCourseConfirmCoursePost$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestResult>> {
    return apiRequestCourseConfirmCoursePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseConfirmCoursePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseConfirmCoursePost(params?: ApiRequestCourseConfirmCoursePost$Params, context?: HttpContext): Observable<RequestResult> {
    return this.apiRequestCourseConfirmCoursePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<RequestResult>): RequestResult => r.body)
    );
  }

  /** Path part for operation `apiRequestCourseResultCoursePost()` */
  static readonly ApiRequestCourseResultCoursePostPath = '/api/Request/Course/ResultCourse';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCourseResultCoursePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseResultCoursePost$Response(params?: ApiRequestCourseResultCoursePost$Params, context?: HttpContext): Observable<StrictHttpResponse<RequestResult>> {
    return apiRequestCourseResultCoursePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCourseResultCoursePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiRequestCourseResultCoursePost(params?: ApiRequestCourseResultCoursePost$Params, context?: HttpContext): Observable<RequestResult> {
    return this.apiRequestCourseResultCoursePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<RequestResult>): RequestResult => r.body)
    );
  }

  /** Path part for operation `apiRequestCoursePreviewCertificateGet()` */
  static readonly ApiRequestCoursePreviewCertificateGetPath = '/api/Request/Course/PreviewCertificate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRequestCoursePreviewCertificateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCoursePreviewCertificateGet$Response(params?: ApiRequestCoursePreviewCertificateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseCertificate>> {
    return apiRequestCoursePreviewCertificateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRequestCoursePreviewCertificateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRequestCoursePreviewCertificateGet(params?: ApiRequestCoursePreviewCertificateGet$Params, context?: HttpContext): Observable<CourseCertificate> {
    return this.apiRequestCoursePreviewCertificateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CourseCertificate>): CourseCertificate => r.body)
    );
  }

}
